(function () {
  if (!window.fetch) return;

  function cleanupMetallicTaggedItems() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        let hasMetallicKit = false;
        const updates = {};

        cart.items.forEach(item => {
          const title = (item.product_title || '').toLowerCase();

          // ✅ Detect PAID Metallic Kit
          if (
            title.includes('metallic') &&
            title.includes('kit') &&
            item.final_price > 0
          ) {
            hasMetallicKit = true;
          }
        });

        // ❌ No kit → remove tagged child items
        if (!hasMetallicKit) {
          cart.items.forEach(item => {
            const tags = item.product_tags || [];
            if (tags.includes('metallic-bundle-child')) {
              updates[item.key] = 0;
            }
          });
        }

        if (Object.keys(updates).length) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
        }
      });
  }

  document.addEventListener('DOMContentLoaded', cleanupMetallicTaggedItems);
  document.addEventListener('booster:content:update', cleanupMetallicTaggedItems);

  // Side cart async safety
  setTimeout(cleanupMetallicTaggedItems, 300);
  setTimeout(cleanupMetallicTaggedItems, 800);
  setTimeout(cleanupMetallicTaggedItems, 1500);
})();
